import { formatarDataISO } from "../../lib/formato/data";
import type { DiaDeRisco } from "../../lib/dashboard/tipos";
import { corSeveridade, rotuloSeveridade } from "./severidade";

/*
 * Tabela de dias de risco do dashboard (Tela 1). Espelha o padrão `<table>` das
 * tabelas existentes (TabelaRegras/TabelaTrilha): colunas Data (`formatarDataISO`,
 * pt-BR timezone-safe) · Alertas (contagem) · Severidade (rótulo + cor mapeada
 * aos tokens CPMH, via `./severidade`).
 *
 * Vazio (`dias.length === 0`) → "Sem dias de risco no período." Só tokens CPMH.
 */

interface DiasDeRiscoTabelaProps {
  dias: DiaDeRisco[];
}

export function DiasDeRiscoTabela({
  dias,
}: DiasDeRiscoTabelaProps): JSX.Element {
  if (dias.length === 0) {
    return (
      <p className="font-corpo text-base text-off-black">
        Sem dias de risco no período.
      </p>
    );
  }

  return (
    <table className="w-full border-collapse font-corpo text-base text-off-black">
      <thead>
        <tr className="border-b border-platinum text-left">
          <th className="py-2 pr-4 font-subtitulo">Data</th>
          <th className="py-2 pr-4 font-subtitulo">Alertas</th>
          <th className="py-2 pr-4 font-subtitulo">Severidade</th>
        </tr>
      </thead>
      <tbody>
        {dias.map((dia) => (
          <tr key={dia.data} className="border-b border-platinum">
            <td className="py-2 pr-4">{formatarDataISO(dia.data)}</td>
            <td className="py-2 pr-4">{dia.alertas_count}</td>
            <td className={`py-2 pr-4 ${corSeveridade(dia.max_severidade)}`}>
              {rotuloSeveridade(dia.max_severidade)}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
